.nudge {
	position: fixed;
	inset-block-end: var(--spacing-4);
	inset-inline-start: 50%;
	z-index: calc(var(--z-overlay) + 2);
	display: flex;
	gap: var(--spacing-4);
	align-items: center;
	inline-size: min(92vw, 26rem);
	padding: var(--spacing-3) var(--spacing-4);

	/* A modal dialog (the task drawer) sets `pointer-events: none` on <body> while open,
	   which would leave this nudge visible but unclickable. Re-enable it explicitly so the
	   Reload / Dismiss buttons stay usable over an open drawer. */
	pointer-events: auto;
	background-color: var(--colour-background-raised);
	border: 1px solid var(--colour-border-subtle);
	border-inline-start: 3px solid var(--colour-brand-primary);
	border-radius: var(--radius-md);
	box-shadow: var(--shadow-md);
	transform: translateX(-50%);
	animation: nudge-in var(--motion-base) var(--ease-standard);

	.body {
		display: flex;
		flex: 1;
		flex-direction: column;
		gap: var(--spacing-1);
		min-inline-size: 0;
	}

	.title {
		margin: 0;
		font-size: var(--font-size-sm);
		font-weight: var(--font-weight-medium);
		color: var(--colour-text-primary);
	}

	.description {
		margin: 0;
		font-size: var(--font-size-sm);
		color: var(--colour-text-secondary);
	}

	.actions {
		display: flex;
		flex-shrink: 0;
		gap: var(--spacing-2);
		align-items: center;
	}
}

@keyframes nudge-in {
	from {
		opacity: 0;
		transform: translate(-50%, var(--spacing-3));
	}

	to {
		opacity: 1;
		transform: translate(-50%, 0);
	}
}

@media (prefers-reduced-motion: reduce) {
	.nudge {
		animation: none;
	}
}
